function showLoading(): void {
    let jqExtend: JQueryStaticExtend = $;

    jqExtend.ShLoading && jqExtend.ShLoading('show', $('body'));
}

function hideLoading(): void {
    let jqExtend: JQueryStaticExtend = $;
    
    jqExtend.ShLoading && jqExtend.ShLoading('hide', $('body'))
}

function tips(msg: string): void {
    cabin.widgets.tips.show(msg);
}

export {
    showLoading,
    hideLoading,
    tips
};
